const region = "us-east-1";
const origin = window.location.origin;

const dev = {
  appSettingsData: {
    // generate a file format limit of video file
    federatedEngageAIProvider: "wl-logostore-dev-idp",
  },

  amplify_config: {
    Auth: {
      mandatorySignIn: true,
      region: region,
      userPoolId: "us-east-1_9hNfPISLN",
      userPoolWebClientId: "75oscq9s4ledv9lcoho4q3339s",
    },
    oauth: {
      domain: "wl-pd-logostore.auth.us-east-1.amazoncognito.com",
      scope: [],
      redirectSignIn: `${origin}/image-verification`,
      redirectSignOut: `${origin}/image-verification`,
      responseType: "code",
      clientId: "75oscq9s4ledv9lcoho4q3339s",
    },
    API: {
      endpoints: [
        {
          name: "logoCloud",
          // endpoint: "https://api.dev.wl-dms.com",
          endpoint: "https://api.wl-dev-logostore.com",
          region: region,
        },
      ],
    },
  },
};
// type demoType = typeof demo

export type DevType = typeof dev;
export default dev;
